module.exports = __webpack_public_path__ + "static/media/dlogo.823cb589.svg";